import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { callCreateNewClient } from './firebase'; // 🔥 استيراد الدالة المساعدة

function SignupPage() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    brandName: '',
    brandOwnerWhatsApp: '',
    easyOrderDomain: '', // 🔥 EasyOrder domain
    ezyApiKey: '', // 🔥 EasyOrder API Key
    storeId: '', // 🔥 EasyOrder Store ID
    // ⚠️ ezyWebhookSecret سيتم إدخاله لاحقاً في WebhookSetupPage
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // --- بداية التعديل: تنظيف وتوحيد رقم الواتساب ---

    // 1. بناخد الرقم من الـ state وننضفه من المسافات
    let phoneNumber = formData.brandOwnerWhatsApp.trim();
    // 2. بنشيل أي أقواس أو شرطات أو مسافات زيادة
    phoneNumber = phoneNumber.replace(/[\s-()]/g, '');

    // 3. بنعالج الحالات المختلفة للأرقام المصرية
    
    // Case 1: لو الرقم بيبدأ بـ "01" (مثال: 01012345678)
    if (phoneNumber.startsWith('01') && phoneNumber.length === 11) {
      phoneNumber = '20' + phoneNumber.substring(1); // هيتحول لـ 201012345678
    }
    // Case 2: لو الرقم بيبدأ بـ "1" (مثال: 1012345678 - دي الحالة اللي بتحصل معاك)
    else if (phoneNumber.startsWith('1') && phoneNumber.length === 10) {
      phoneNumber = '20' + phoneNumber; // هيتحول لـ 201012345678
    }
    // Case 3: لو الرقم بيبدأ بـ "+20" (مثال: +201012345678)
    else if (phoneNumber.startsWith('+20') && phoneNumber.length === 13) {
      phoneNumber = phoneNumber.substring(1); // هيتحول لـ 201012345678
    }
    // Case 4: لو الرقم بيبدأ بـ "0020" (مثال: 00201012345678)
    else if (phoneNumber.startsWith('0020') && phoneNumber.length === 14) {
      phoneNumber = phoneNumber.substring(2); // هيتحول لـ 201012345678
    }
    // Case 5: لو الرقم بيبدأ بـ "20" أصلاً (مثال: 201012345678)
    // أو أي رقم دولي تاني (مثال: 9665...)
    // مش هنعمل حاجة، هنسيبه زي ما هو.

    // --- نهاية التعديل ---

    try {
      // 4. بنجهز البيانات اللي هتتبعت للباك إند
      const dataToSend = {
        email: formData.email,
        password: formData.password,
        brand_name: formData.brandName,
        brand_owner_whatsapp: parseInt(phoneNumber), // تحويل لرقم
        platform_type: 'easyorder', // 🔥 نوع المنصة
        // حقول EasyOrder
        easyOrder_domain: formData.easyOrderDomain,
        ezy_api_key: formData.ezyApiKey,
        ezy_webhook_secret: null, // سيتم إدخاله لاحقاً
        store_id: formData.storeId,
        // حقول Shopify = null
        shopify_access_token: null,
        shopify_domain: null,
        shopify_shared_secret: null,
        // ⚠️ لا نضع webhook_path_id هنا - Cloud Function هيولده تلقائياً!
        // حقول افتراضية
        balance: 0,
        isActive: true,
        chatbot: false,
        low_balance_notified: false,
        auto_cancel: false
      };

      // 🔥 نادي على الـ Cloud Function وابعتلها البيانات
      const result = await callCreateNewClient(dataToSend);

      if (result.status === 'success') {
        // لو كله تمام، وديه على الداش بورد (عشان يشوف صفحة الـ Webhook)
        alert('تم إنشاء الحساب بنجاح! جاري تحويلك لإعداد الـ Webhook...');
        // هيفضل مسجل دخوله (لأننا عملنا اليوزر في Auth)
        navigate('/dashboard');
      } else {
        setError(result.message || 'حدث خطأ غير معروف');
      }
    } catch (error) {
      // اعرض الأخطاء اللي جاية من الباك إند
      if (error.message.includes('already-exists') || error.message.includes('مسجل بالفعل') || error.message.includes('مستخدم')) {
        setError(error.message || 'الاسم أو البيانات مسجلة بالفعل');
      } else {
        setError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  // (ده مجرد شكل فورم بسيط، إنت ممكن تعدل الـ CSS براحتك)
  return (
    <div style={{ padding: '20px', maxWidth: '500px', margin: 'auto' }}>
      <h2>إنشاء حساب براند جديد (EasyOrder)</h2>
      <form onSubmit={handleSubmit}>
        <input 
          type="email" 
          name="email" 
          placeholder="الإيميل" 
          value={formData.email} 
          onChange={handleChange} 
          required 
          style={inputStyle} 
        />
        <input 
          type="password" 
          name="password" 
          placeholder="كلمة المرور" 
          value={formData.password} 
          onChange={handleChange} 
          required 
          style={inputStyle} 
        />
        <input 
          type="text" 
          name="brandName" 
          placeholder="اسم البراند (مثال: Cleanzy)" 
          value={formData.brandName} 
          onChange={handleChange} 
          required 
          style={inputStyle} 
        />
        <input 
          type="text" 
          name="brandOwnerWhatsApp" 
          placeholder="رقم واتساب صاحب البراند (مثال: 201558329566)" 
          value={formData.brandOwnerWhatsApp} 
          onChange={handleChange} 
          required 
          style={inputStyle} 
        />
        <input 
          type="text" 
          name="easyOrderDomain" 
          placeholder="دومين EasyOrder (مثال: cleanzyeg.myeasyorders.com)" 
          value={formData.easyOrderDomain} 
          onChange={handleChange} 
          required 
          style={inputStyle} 
        />
        <input 
          type="text" 
          name="storeId" 
          placeholder="Store ID (مثال: fcce61c5-ca66-4a33-9b0e-2f0c3c00fc36)" 
          value={formData.storeId} 
          onChange={handleChange} 
          required 
          style={inputStyle} 
        />
        <input 
          type="text" 
          name="ezyApiKey" 
          placeholder="EasyOrder API Key (مثال: 043fbf56-823a-479b-96a2-27b5f1786672)" 
          value={formData.ezyApiKey} 
          onChange={handleChange} 
          required 
          style={inputStyle} 
        />
        
        <button type="submit" disabled={loading} style={buttonStyle}>
          {loading ? 'جاري الإنشاء...' : 'إنشاء حساب'}
        </button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <p>
        لديك حساب بالفعل؟ <Link to="/">سجل دخول من هنا</Link>
      </p>
    </div>
  );
}

// (ستايلات بسيطة عشان الفورم تظهر)
const inputStyle = {
  width: '100%',
  padding: '10px',
  margin: '10px 0',
  boxSizing: 'border-box',
};

const buttonStyle = {
  width: '100%',
  padding: '12px',
  backgroundColor: '#007bff',
  color: 'white',
  border: 'none',
  cursor: 'pointer',
  fontSize: '16px',
};

export default SignupPage;